<script setup>
import {ref, computed, onBeforeMount} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useStore} from 'vuex'
import MonitoringForm from './MonitoringForm.vue'
import { useCheckProjectAccess } from '@/composables/useCheckAccess'

const store = useStore()
const route = useRoute()
const router = useRouter()

const projectId = route.params.project_id
const project = computed(() => store.getters['project/current'])
const canRead = ref(false)

onBeforeMount(async () => {
  await store.dispatch('project/fetchProject', projectId)
  canRead.value = useCheckProjectAccess(project.value, 'project_settings', ['read'])

  if (!canRead.value) {
    router.push({name: 'ProjectHome', params: {project_id: projectId}})
  }
})
</script>

<template>
  <div class="max-w-[60%] space-y-3" v-if="canRead">
    <MonitoringForm v-if="project.project_id" :project="project" />
  </div>
</template>
